import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import i18nSeo from "../utils/i18nSeo";
import { useTranslation } from "react-i18next";

const HelmetJS = () => {
    const location = useLocation();
    const { t } = useTranslation("", {
        i18n: i18nSeo, useSuspense: false
    });
    const useSEO = process.env.REACT_APP_SEO === "TRUE";


    const [title, setTitle] = useState("");
    const [desc, setDesc] = useState("");
    const [keyword, setKeyword] = useState("");

    useEffect(() => {
        if (!useSEO) return;

        let pathKey = location.pathname;

        setTitle(t(`${pathKey}.title`, { defaultValue: "" }));
        setDesc(t(`${pathKey}.desc`, { defaultValue: "" }));
        setKeyword(t(`${pathKey}.keyword`, { defaultValue: "" }));
    }, [location.pathname, t]);

    return (
        <>
            <Helmet>
                <title>
                    {useSEO
                        ? title || process.env.REACT_APP_SEO_DEFAULT
                        : process.env.REACT_APP_SEO_DEFAULT}
                </title>

                <meta
                    name="description"
                    content={useSEO ? desc : ""}
                />
                <meta
                    name="keywords"
                    content={useSEO ? keyword : ""}
                />
            </Helmet>
        </>
    );
}

export default HelmetJS;